import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';
import { ReviewReportsPageComponent } from './review-reports-page.component';
import { ReviewReportModalComponent } from './review-report-modal/review-report-modal.component';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.reports',
    url: '/reports',
    data: {
      requireLogin: true
    },
    params: {
      reportType: null
    }
  },
  {
    name: 'missioncontrol.reports.reviewReports',
    url: '/reviewReports',
    // The parent reports state has no view, so the child targets the missioncontrol ui-view directly.
    views: {
      '$default@missioncontrol': { component: ReviewReportsPageComponent }
    },
    data: {
      requireLogin: true
    }
  }
];

@NgModule({
  declarations: [ReviewReportsPageComponent, ReviewReportModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    DataTablesModule,
    TooltipModule.forRoot(),
    PipesModule,
    SkeletonLoaderModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [ReviewReportsPageComponent, ReviewReportModalComponent],
  exports: [ReviewReportsPageComponent]
})
export class ReviewReportsPageModule { }
